import { useEffect, useRef, useState } from "react";

// Renders only `count` items and reveals more as a sentinel scrolls into view.
// Keeps galleries smooth well past 1,000 photos by capping live DOM/img nodes.
export function useInfiniteWindow(total, step = 48) {
  const [count, setCount] = useState(step);
  const sentinelRef = useRef();

  useEffect(() => { setCount(step); }, [total, step]);

  useEffect(() => {
    if (count >= total) return;
    const el = sentinelRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => { if (entries[0].isIntersecting) setCount((c) => Math.min(c + step, total)); },
      { rootMargin: "800px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [total, step, count]);

  return { count, sentinelRef, hasMore: count < total };
}
